export const AUTH_TOKEN_STORAGE_KEY = '@HauserWirthStore:authToken';


// WEBPACK FOOTER //
// ./src/constants/storageConstants.js